export const SITE_URL = 'https://conmantheseries.com'
export const DEFAULT_IMAGE = '/assets/images/2017/07/front-page-marquee-EMMY.webp'
export const TWITTER_SITE = '@ConManSeries'

export type PageSeo = {
  title: string
  description: string
  image?: string
  type?: 'website' | 'article'
  crumbs: { name: string; path: string }[]
}

export const PAGE_SEO: Record<string, PageSeo> = {
  '/': {
    title: 'Con Man | Alan Tudyk & Nathan Fillion Series, Game & Comic',
    description:
      'The Con Man comedy series from Alan Tudyk and Nathan Fillion, plus the Con Man mobile game and Spectrum comic. Watch trailers and explore the game and comic.',
    crumbs: [{ name: 'Home', path: '/' }],
  },
  '/season-1/': {
    title: 'Season 1 | Con Man',
    description:
      'Con Man Season 1 follows Wray Nerely after Spectrum was canceled. See the Season 1 cast, behind-the-scenes photos, and watch on Comic Con HQ.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'Season 1', path: '/season-1/' },
    ],
  },
  '/season-2/': {
    title: 'Season 2 | Con Man',
    description:
      'In Season 2 Wray Nerely must confess to Jack Moore that he wants nothing to do with the Spectrum movie. Watch it on Comic Con HQ and meet the Season 2 cast.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'Season 2', path: '/season-2/' },
    ],
  },
  '/game/': {
    title: 'Con Man the Game | Con Man',
    description:
      'Build your own comic convention in Con Man the Game. Join Alan Tudyk and Nathan Fillion, fight Spectrum aliens, and download the free game to play now.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'Game', path: '/game/' },
    ],
  },
  '/game/termsofuse/': {
    title: 'Game Terms of Use | Con Man',
    description:
      'Terms of Service for Con Man the Game from Monkey Strength Productions, covering your Con Man Game Account, content, entitlements, and virtual currency.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'Game', path: '/game/' },
      { name: 'Terms of Use', path: '/game/termsofuse/' },
    ],
  },
  '/spectrum-comic-book/': {
    title: 'Spectrum Comic | Con Man',
    description:
      'Spectrum is the Con Man comic: a four-book series by PJ Haarsma and Alan Tudyk. Meet the team, read the Q&A, and get Issue #0 and Issue #1 today.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'Comic Book', path: '/spectrum-comic-book/' },
    ],
  },
  '/press/': {
    title: 'Press | Con Man',
    description:
      'Press coverage of Con Man, from SYFY and Casper Van Dien to Indiegogo records. Watch trailers and read breaking-records coverage of the series and game.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'Press', path: '/press/' },
    ],
  },
  '/faq/': {
    title: 'FAQ | Con Man',
    description:
      'Frequently asked questions about watching Con Man on Comic-Con HQ, Vimeo access codes, Indiegogo perks, credits, DVD shipments, and upcoming cons.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'FAQ', path: '/faq/' },
    ],
  },
  '/updates/': {
    title: 'News | Con Man',
    description:
      'News and updates from Con Man, including Emmy nominations, Con Man the Game development notes, new game forums, and Spectrum comic announcements.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'News', path: '/updates/' },
    ],
  },
  '/updates/page/2/': {
    title: 'News Page 2 | Con Man',
    description:
      'Older Con Man news, page 2 of the archive: game updates, Free Comic Book Day Spectrum signings, the fanfiction contest, and Season 2 set photos.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'News', path: '/updates/' },
      { name: 'Page 2', path: '/updates/page/2/' },
    ],
  },
  '/updates/page/3/': {
    title: 'News Page 3 | Con Man',
    description:
      'Con Man news archive page 3, with early series updates, the Salt Lake Comic Con sneak peek, NYCC bus, Vimeo ownership, and Pledge Manager notes.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'News', path: '/updates/' },
      { name: 'Page 3', path: '/updates/page/3/' },
    ],
  },
  '/con-man-game-forums/': {
    title: 'Game Forums | Con Man',
    description:
      'Community forums for Con Man the Game: news, volunteers, VIP panels, contests, and the green room for players to share ideas and meet friends.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'Game Forums', path: '/con-man-game-forums/' },
    ],
  },
  '/404/': {
    title: 'Page not found | Con Man',
    description:
      'Oops! That page cannot be found. Con Man is an EMMY nominated series from Alan Tudyk, Nathan Fillion, and PJ Haarsma, and now it is a game too.',
    crumbs: [
      { name: 'Home', path: '/' },
      { name: 'Not found', path: '/404/' },
    ],
  },
}

export function pageTitle(topic: string) {
  const suffix = ' | Con Man'
  let t = decodeEntities(topic.replace(/\s+-\s+Con Man\s*$/i, '').trim())
  t = t.replace(/\s+/g, ' ')
  if (t.endsWith(suffix)) t = t.slice(0, -suffix.length).trim()
  if (t.length + suffix.length > 60) {
    t = t.slice(0, 60 - suffix.length).trim()
  }
  return `${t}${suffix}`
}

export function decodeEntities(value: string) {
  return value
    .replace(/&#8217;|&#038;|&amp;#8217;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/&nbsp;/g, ' ')
    .replace(/&ldquo;|&rdquo;|&#8220;|&#8221;/g, '"')
    .replace(/&rsquo;|&#8217;/g, "'")
    .replace(/&hellip;|&#8230;/g, '...')
    .replace(/&#\d+;/g, ' ')
}

export function textFromHtml(html: string) {
  return decodeEntities(
    html
      .replace(/<script[\s\S]*?<\/script>/gi, ' ')
      .replace(/<style[\s\S]*?<\/style>/gi, ' ')
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim(),
  )
}

export function excerptFromHtml(html: string, min = 140, max = 160) {
  const content = html.match(/<div class="entry-content content">([\s\S]*?)<span class="cp-load-after-post">/)?.[1] ?? html
  const stripped = content.replace(/\[[^\]]*\]/g, ' ')
  let text = textFromHtml(stripped)
  if (text.length < min) text = textFromHtml(html.replace(/\[[^\]]*\]/g, ' '))
  if (text.length > max) {
    const sliced = text.slice(0, max)
    const space = sliced.lastIndexOf(' ')
    text = (space >= min ? sliced.slice(0, space) : sliced).replace(/[,:;–-]\s*$/, '')
    if (!/[.!?]$/.test(text)) text += '.'
  }
  return text
}

export function parsePostHtml(html: string) {
  const headline = decodeEntities(
    html.match(/<h1 class="entry-title">[\s\S]*?<\/i>\s*([\s\S]*?)<\/h1>/)?.[1]?.replace(/\s+/g, ' ').trim() ?? '',
  )
  const author = html.match(/<p class="p-meta"><span>([^<]+)<\/span>/)?.[1] ?? ''
  const datePublished = html.match(/datetime="([^"]+)"/)?.[1] ?? ''
  const image = html.match(/<img[^>]+src="([^"]+)"/)?.[1] ?? DEFAULT_IMAGE
  return { headline, author, datePublished, image }
}

export function absoluteUrl(path: string) {
  if (path.startsWith('http')) return path
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`
}

export function breadcrumbJsonLd(crumbs: { name: string; path: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: absoluteUrl(crumb.path),
    })),
  }
}

export const TV_SERIES = {
  '@context': 'https://schema.org',
  '@type': 'TVSeries',
  '@id': `${SITE_URL}/#series`,
  name: 'Con Man',
  url: `${SITE_URL}/`,
  genre: 'Comedy',
  creator: { '@type': 'Person', name: 'Alan Tudyk' },
  actor: [
    { '@type': 'Person', name: 'Alan Tudyk' },
    { '@type': 'Person', name: 'Nathan Fillion' },
  ],
  sameAs: ['https://en.wikipedia.org/wiki/Con_Man_(web_series)'],
}

export const WEB_SITE = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Con Man',
  url: `${SITE_URL}/`,
}

export const VIDEO_GAME = {
  '@context': 'https://schema.org',
  '@type': 'VideoGame',
  name: 'Con Man the Game',
  url: `${SITE_URL}/game/`,
  description: PAGE_SEO['/game/'].description,
  isBasedOn: { '@id': `${SITE_URL}/#series` },
}

export const COMIC_SERIES = {
  '@context': 'https://schema.org',
  '@type': 'ComicSeries',
  name: 'Spectrum',
  url: `${SITE_URL}/spectrum-comic-book/`,
  description: PAGE_SEO['/spectrum-comic-book/'].description,
  isBasedOn: { '@id': `${SITE_URL}/#series` },
}

export function jsonLdForPath(
  path: string,
  extra?: { headline?: string; datePublished?: string; author?: string; image?: string },
) {
  const page = PAGE_SEO[path]
  const crumbs = page?.crumbs ?? [
    { name: 'Home', path: '/' },
    { name: extra?.headline || 'Page', path },
  ]
  const blocks: Record<string, unknown>[] = [breadcrumbJsonLd(crumbs)]
  if (path === '/') {
    blocks.unshift(WEB_SITE, TV_SERIES)
  } else if (path === '/game/') {
    blocks.unshift(VIDEO_GAME)
  } else if (path === '/spectrum-comic-book/') {
    blocks.unshift(COMIC_SERIES)
  } else if (extra?.headline) {
    blocks.unshift({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: extra.headline,
      datePublished: extra.datePublished,
      author: extra.author ? { '@type': 'Person', name: extra.author } : undefined,
      image: extra.image ? absoluteUrl(extra.image) : absoluteUrl(DEFAULT_IMAGE),
      url: absoluteUrl(path),
      isPartOf: { '@id': `${SITE_URL}/#series` },
    })
  }
  return blocks
}
